import(/* webpackMode: "eager", webpackExports: ["PlayerSearchClient"] */ "/Users/yk/Dev/BaseballDataViewer/nextjs/components/client/HomeClient.tsx");
